import React from 'react';
import styles from './FeatureCard.module.css';

const FeatureCard = (props) => {
    const {
        containerVariant = '',
        innerContainerVariant = '',
        backgroundVariant = '',
        contentContainerVariant = '',
        number = '',
        numberClassName = '',
        title = '',
        titleClassName = '',
        description = '',
        descriptionClassName = '',
        theme = '' // 'orange' or 'white'
    } = props;

    // Determine text colors based on theme
    const textColor = theme === 'orange' || contentContainerVariant.includes('orangeBg')
        ? '#ffffff'
        : '#000000';

    return (
        <div className={`${styles.featureCard} ${containerVariant}`}>
            <div className={styles.absoluteOverlay}></div>
            <div className={`${styles.innerContainer} ${innerContainerVariant}`}>
                <div className={`${styles.backgroundWrapper} ${backgroundVariant}`}>
                    <div className={`${styles.contentBackground} ${contentContainerVariant}`}></div>
                    <div className={styles.contentGrid}>
                        <div className={styles.numberContainer}>
                            <div className={styles.textContainer}>
                                <div className={styles.numberWrapper}>
                                    <p
                                        className={styles.number}
                                        style={{ color: textColor }}
                                    >
                                        {number}
                                    </p>
                                </div>
                            </div>
                            <div className={styles.titleContainer}>
                                <div className={styles.descriptionContainer}>
                                    <h2
                                        className={styles.title}
                                        style={{ color: textColor }}
                                    >
                                        {title}
                                    </h2>
                                </div>
                                <div className={styles.descriptionWrapper}>
                                    <p
                                        className={styles.description}
                                        style={{ color: textColor }}
                                    >
                                        {description}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FeatureCard;

// import React from 'react';
// import styles from './FeatureCard.module.css';

// const FeatureCard = (props) => {
//     return (
//         <div
//             role="presentation"
//             className={`${styles.featureCard} ${props.containerVariant}`}
//         >
//             <div className={styles.absoluteOverlay}></div>
//             <div className={`${styles.innerContainer} ${props.innerContainerVariant}`}>
//                 <div
//                     role="presentation"
//                     className={`${styles.backgroundWrapper} ${props.backgroundVariant}`}
//                 >
//                     <div className={props.contentContainerVariant}></div>
//                     <div className={styles.contentGrid}>
//                         <div
//                             role="presentation"
//                             className={styles.numberContainer}
//                         >
//                             <div className={styles.absoluteOverlay}></div>
//                             <div
//                                 role="presentation"
//                                 className={styles.textContainer}
//                             >
//                                 <div className={styles.absoluteOverlay}></div>
//                                 <div className={styles.numberWrapper}>
//                                     <p
//                                         className={styles.number}
//                                         style={{
//                                             color: props.numberClassName === 'text-black' ? '#000000' : '#ffffff',
//                                             fontWeight: 'bold',
//                                             fontSize: '24px', // Increased from 14.4231px
//                                             lineHeight: '24px',
//                                             fontFamily: "'Wix Madefor Display V2', sans-serif",
//                                             margin: 0
//                                         }}
//                                     >
//                                         {props.number}
//                                     </p>
//                                 </div>
//                             </div>
//                             <div
//                                 role="presentation"
//                                 className={styles.titleContainer}
//                             >
//                                 <div className={styles.absoluteOverlay}></div>
//                                 <div className={styles.descriptionContainer}>
//                                     <h2
//                                         className={styles.title}
//                                         style={{
//                                             color: props.titleClassName === 'text-black' ? '#000000' : '#ffffff',
//                                             fontSize: '36px', // Increased from 30.7692px
//                                             lineHeight: '44px',
//                                             fontFamily: "'MadeFor Display Bold', sans-serif",
//                                             margin: 0,
//                                             fontWeight: 'bold' // Added bold
//                                         }}
//                                     >
//                                         {props.title}
//                                     </h2>
//                                 </div>
//                                 <div className={styles.descriptionWrapper}>
//                                     <p
//                                         style={{
//                                             color: props.descriptionClassName === 'text-black' ? '#000000' : '#ffffff',
//                                             fontSize: '18px',
//                                             lineHeight: '28.8px',
//                                             fontFamily: "'Wix Madefor Text V2', sans-serif",
//                                             fontWeight: '500',
//                                             margin: 0,
//                                             caretColor: 'transparent'
//                                         }}
//                                     >
//                                         {props.description}
//                                     </p>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default FeatureCard;